import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./CreateChatGroupModal.style";
import * as P from "../../../../../utils/pipes";
import { Actions } from "../../../../../utils/actionsIds";

// graphQL
import { useQuery, useMutation } from "@apollo/client";

// hooks
import useUploadTempImg from "../../../../../hooks/useUploadTempImg"
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction/ZaiaReaction";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent";
import ZaiaSelect from "../../../../zaiaComponents/zaiaSelect";
import useRecordNavigation from "../../../../../hooks/useRecordNavigation";
import ZaiaInput from "../../../../zaiaComponents/zaiaInput";
import { QUERY_GET_PROCESS_STAGES_BY_PROCESS_IDS } from "../../../../../graphql/queries/UserToProcess";
import { MUTATION_UPDATE_USER_TO_PROCESS_FOLLOW_UP } from "../../../../../graphql/mutations/UserToProcess";
import { QUERY_GET_PROCESS_NAMES } from "../../../../../graphql/queries/Process";
import usePatientList from "../../../../../hooks/usePatientList";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import Popup from "reactjs-popup";
import useDoctorData from "../../../../../hooks/useDoctorData";
import { INSERT_NEW_CHAT_GROUP_WITH_PATIENTS } from "../../../../../graphql/mutations/Chat";
import useUploadDoc from "../../../../../hooks/useUploadDoc";

const zaiaImgLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const UPLOAD_GUIDE_PATIENT_ENDPOINT = process.env.REACT_APP_PATIENT_GUIDE_MEDPALM_ENDPOINT;
const BUCKET_CHAT_GROUPS = process.env.REACT_APP_BUCKET_CHAT_GROUPS;

function CreateChatGroupModal({ 
  setActiveCreateChatGroupModal
}) {

  const [insertNewChatGroup, {loading: insertNewChatGroupLoading}] = useMutation(INSERT_NEW_CHAT_GROUP_WITH_PATIENTS);
  const [formSuccess, setFormSuccess] = useState(null);
  const [successText, setSuccessText] = useState("");
  const { recordAction } = useRecordNavigation();
  const [selectParticipantsActived, setSelectParticipantsActived] = useState(false);
  const {t, i18n: { language }} = useTranslation("global");
  const [processSelected, setProcessSelected] = useState();
  const [chatName, setChatName] = useState("");
  const [chatDescription, setChatDescription] = useState("");
  const [selectedPatients, setSelectedPatients] = useState([]);
  const { data: processData } = useQuery( QUERY_GET_PROCESS_NAMES );  
  const hiddenFileInput = React.useRef(null);
  const {tempImg, dataImg, uploadImg, deleteImg} = useUploadTempImg();  
  const {uploadDoc, data, loading, error, cleanAction} = useUploadDoc();  
  const { doctorData } = useDoctorData();

  const {
    patientList,
    patientListLoading,
    patientListError
  } = usePatientList(processSelected)

  const handleClickInputImg = () => {
    hiddenFileInput.current.click();    
  };

  useEffect(() => {
    console.log(selectParticipantsActived);
  }, [selectParticipantsActived]);
   
  const handleSubmit = async () => {

    let uploadedImgGroup = null;

    if(dataImg) {
      let { data: { uploaded_file_data } } = await uploadDoc(dataImg, UPLOAD_GUIDE_PATIENT_ENDPOINT, BUCKET_CHAT_GROUPS);
      uploadedImgGroup = uploaded_file_data[0].file_url;
    }
    

    const variables = {
      description: chatDescription,
      nameChat: chatName,
      imagen: uploadedImgGroup,
      userToProcessId: selectedPatients.length > 0 
        ? selectedPatients[0].userToProcesses.find((userToProcess) => userToProcess.process.id === processSelected).id 
        : null,
      patientsToChat: selectedPatients?.map((patient) => {
        return {
          userId: patient.id
        }
      })
    }

    try {
      await insertNewChatGroup({
        variables
      });
      setFormSuccess(true);
      setChatDescription("");
      setChatName("");
      setSelectedPatients([]);
      setSelectParticipantsActived(false);
      setProcessSelected(null);
      setSuccessText(t("chat.createChatGroup.successGroupChat"));
      deleteImg();
      cleanAction();
    } catch (error) {
      setFormSuccess(false);
      setSuccessText(t("globally.errorForm"));
      console.log(error);
    }
  }

  const formCompleted = useMemo(() => {
    if(chatName && processSelected) {     
      return true;
    } else {
      return false;
    }
  }, [chatName, chatDescription, processSelected])

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setActiveCreateChatGroupModal(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  if(
    insertNewChatGroupLoading || loading
  ) 
    return(
      <S.CreateChatGroupModal>
        <div className="modal-background">
        </div>
        <div className="modal-container modal-container--response">
          <ZaiaReaction
            widthimg={"150px"}
            zaiaImg={zaiaImgLoading}
            padding={"200px 0px"}
          />
        </div>
      </S.CreateChatGroupModal>
    )

  if(formSuccess)
    return(
      <S.CreateChatGroupModal>
        <div className="modal-background" onClick={() => setActiveCreateChatGroupModal(false)}>
        </div>
        <div className="modal-container modal-container--response">
          <ZaiaModalResponseContent
            button1={() => setFormSuccess(null)}
            button1Text={t("globally.done")}
            formSuccess={formSuccess}
            title={successText}
          />
        </div>
      </S.CreateChatGroupModal>
    )

  if(formSuccess === false || error)
    return(
      <S.CreateChatGroupModal>
        <div className="modal-background" onClick={() => setActiveCreateChatGroupModal(false)}>
        </div>
        <div className="modal-container modal-container--response">
          <ZaiaModalResponseContent
            button1={() => {
              setFormSuccess(null)
              cleanAction()
            }}
            formSuccess={formSuccess}
            button1Text={t("globally.accept")}
            title={t("globally.errorForm")}
            subtitle={successText}
          />
        </div>
      </S.CreateChatGroupModal>
    )    

  return (
    <S.CreateChatGroupModal
    >
      <div className="modal-background" onClick={() => setActiveCreateChatGroupModal(false)}>
      </div>
      <div className="modal-container">
        <div className="header">
          <button className="close"
            onClick={() => setActiveCreateChatGroupModal(false)}
          >
            <i className="close__icon icon zaia-icono-cerrar"></i>
          </button>
          <div className="title">
            <div className="title__text">{t("chat.createChatGroup.createGroup")}</div>
          </div>
        </div>
        {
          selectParticipantsActived &&
          <div className="content">
            <div className="chat-info">
              <div className="chat-info__label">{t("chat.createChatGroup.groupCreation")}</div>
              <div className="chat-info__name">{chatName}</div>
            </div>
            <div className="users-list">
              {
                !patientListError && !patientListLoading && patientList?.length !== 0 &&
                patientList?.map((patient) => 
                  {
                    return(
                      <div 
                        className={`user-item ${selectedPatients?.find((pat) => pat.id === patient.id) && 'user-item--selected'}`}  
                        onClick={() => 
                          {
                            if(selectedPatients?.find((pat) => pat.id === patient.id)) {
                              setSelectedPatients(selectedPatients?.filter((pat) => pat.id !== patient.id))
                            } else {
                              setSelectedPatients([...selectedPatients, patient])
                            }
                          }
                        }
                      >
                        <ZaiaImage
                          size={55}
                          img={patient.picture}
                          rounded={true}
                        />
                        <div className="user-item__info">
                          <div className="user-item__name">{`${patient.name} ${patient.lastname}`}</div>
                        </div>
                      </div>
                    )
                  }
                )
              }
            </div>
          </div>
        }
        {
          !selectParticipantsActived &&
          <div className="content">
            <div className="content__chat-image">
              {
                tempImg
                ? <img src={tempImg} alt="" className="image-preview" />
                : <div 
                  className="image-preview"
                  onClick={handleClickInputImg}
                >
                  <i className="zaia-icono-chat icon zaia-i-upload"></i>
                </div>
              }
              <div className="image-text">
                <div className="image-text__name">{chatName ? chatName : t("chat.createChatGroup.florenzGroupChat")}</div>
                <div className="image-text__upload"onClick={handleClickInputImg} >{t("chat.createChatGroup.uploadPhoto")}</div>
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={uploadImg}
                  style={{display: 'none'}}
                  accept="image/*"  
                />
              </div>
            </div>
            <div className="content__inputs">
              <div className="double-content">
                <div className="field">
                  <div className="field__label">{t("chat.createChatGroup.groupName")}<div className="error">*</div></div>
                  <div className="field__input">
                    <ZaiaInput
                      placeholder={t("chat.createChatGroup.groupNamePlaceholder")}
                      name="descript"
                      type="text"
                      backgroundColor={"#F6F6FF"}
                      borderRadius={"14px"}
                      fontSize={"16px"}
                      padding={"16px 10px"}
                      placeholdertextcolor={"#707582"}
                      textColor={"#1F1F52"}
                      activeBorder={false}
                      value={chatName}
                      getText={(e) => {
                        setChatName(e);
                      }}
                    />
                  </div>
                </div>
                <div className="field field--select">
                  <div className="field__label">{t("chat.createChatGroup.groupProgram")}<div className="error">*</div></div>
                  <div className="field__input">
                    <ZaiaSelect
                      name="descript"
                      type="text"
                      setValue={(e) => 
                        setProcessSelected(e)
                      }
                      value={
                        processSelected
                      }
                      items={processData?.process.filter((process) => process.userToProcesses.length).map(
                        process => {
                          return {
                            value: process.id,
                            text: P.dataTranslation(process.processName, language)
                          }
                        }
                      )}
                      heightList={"200px"}
                      placeholder={t("chat.createChatGroup.groupProgramPlaceholder")}
                      backgroundColor={"#F6F6FF"}
                      borderRadius={"14px"}
                      textarea={true}
                      fontSize={"16px"}
                      padding={"16px 10px"}
                      placeholdertextcolor={"#878792"}
                      textColor={"#1F1F52"}
                      activeBorder={false}
                    />
                  </div>
                </div>
              </div>
              <div className="field">
                <div className="field__label">{t("chat.createChatGroup.groupDescription")}</div>
                <div className="field__input">
                  <ZaiaInput
                    name="descript"
                    type="text"
                    placeholder={t("chat.createChatGroup.groupDescriptionPlaceholder")}
                    backgroundColor={"#F6F6FF"}
                    borderRadius={"14px"}
                    textarea={true}
                    fontSize={"16px"}
                    padding={"10px"}
                    height={"150px"}
                    placeholdertextcolor={"#707582"}
                    textColor={"#1F1F52"}
                    activeBorder={false}
                    value={chatDescription}
                    getText={(e) => {
                      setChatDescription(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        <div className="footer">
          {
            selectParticipantsActived &&
            <div className="footer__left">
              <button className="button-status button-status--secondary"
                onClick={() => {
                  setSelectParticipantsActived(false)
                }}
                >
                <i className="button-status__icon button-status__icon--back icon zaia-icono-atras"></i>
                <div className="button-status__text">{t("globally.back")}</div>
              </button>
            </div>
          } 
          <div className="footer__description">
            <div className="footer__description-text">
              {
                !selectParticipantsActived
                ? <>
                  {t("chat.createChatGroup.alert1")}
                  <div className="error">*</div>
                </> 
                : t("chat.createChatGroup.alert2")
              }
            </div>
          </div>
          <div className="footer__right">
            {
              selectParticipantsActived &&
              <button
                className={
                `button-status button-status--green`
                } 
                onClick={() => {
                  handleSubmit()
                }}
                >
                <div className="button-status__text">{t("chat.createChatGroup.createGroup")}</div>
              </button>
            } 
            {
              !selectParticipantsActived &&
              <button 
                className={
                `button-status 
                  button-status--blue 
                  ${(!formCompleted) && "button-status--disabled"}
                `} 
                onClick={() => {
                  formCompleted && setSelectParticipantsActived(true)
                }}
              >
                {
                  (!formCompleted) && 
                  <i className="button-back__icon icon zaia-i-lock-chat"></i>
                }
                <div className="button-back__text">{t("globally.next")}</div>
              </button>
            }
          </div>
        </div>
      </div>
    </S.CreateChatGroupModal>
  );
}

export default CreateChatGroupModal;
